import React from "react";
import {
	IconButton,
	Tooltip,
	Typography,
	Link,
	Grid,
	LinearProgress,
	Box,
	Avatar,
} from "@mui/material";

import { CommentIcon } from "utility/icons";
import "components/Layout/Sidebar/WorkFlowApprovalStepsHistory/WorkFlowApprovalStepsHistory.css";
import { IStepHistoryComment } from "models/StepHistoryDetail";
import { CustomTooltip } from "components/CustomTooltip";
import { ISupplierDocStepHistory } from "models/VendorPortal/InvoiceUploadSummaryGridDetail";
import { SupplierDocumentStepHistoryStatus } from "utility/enums/supplier-doc-upload";
import { infoIcon } from "assets/images";

const stepHistoryList: ISupplierDocStepHistory[] = [
	{
		supplierDocId: 1,
		supplierDocStepId: 1,
		stepStatusId: 1,
		stepStatus: "Completed",
		sequenceNumber: 1,
		cutOffTime: "15:30pm Business days excluding holidays",
		dateSubmitted: "09/12/2022 - 09:22 am",
		dateReviewed: "",
		dateCaptured: "",
		datePaid: "",
		stepNumber: 1.0,
		description: "Supplier Invoice Submission",
		assignToUsers: [
			{ userId: 1, fullName: "Lefatse Mhlaba", isTaskCompleted: true },
		],
		duration: "",
		averageDuration: "",
		completedBy: "",
		stepCompletedInPercentage: 40,
		comments: [{ comment: "completed", fullName: "Lefatse Mhlaba" }],
		cutOffDescription: "Submitted 6 hours, 8 minutes before cut-of",
		cutOffColor: "red-text",
	},
	{
		supplierDocId: 1,
		supplierDocStepId: 1,
		stepStatusId: 4,
		stepStatus: "Recalled",
		sequenceNumber: 2,
		cutOffTime: "",
		dateSubmitted: "",
		dateReviewed: "09/12/2022 - 10:12 am",
		dateCaptured: "",
		datePaid: "",
		stepNumber: 2.0,
		description: "End User Review",
		assignToUsers: [
			{ userId: 3, fullName: "ETQ A", isTaskCompleted: true },
			{ userId: 2, fullName: "Dan Davis", isTaskCompleted: false },
		],
		duration: "",
		averageDuration: "",
		completedBy: "",
		stepCompletedInPercentage: 40,
		comments: [{ comment: "completed", fullName: "ETQ A" }],
		cutOffDescription: "",
	},
	{
		supplierDocId: 1,
		supplierDocStepId: 1,
		stepStatusId: 1,
		stepStatus: "Completed",
		sequenceNumber: 3,
		cutOffTime: "15:30pm Business days excluding holidays",
		dateSubmitted: "09/12/2022 - 15:30 am",
		dateReviewed: "",
		dateCaptured: "",
		datePaid: "",
		stepNumber: 1.0,
		description: "Supplier Invoice Submission",
		assignToUsers: [
			{ userId: 1, fullName: "Lefatse Mhlaba", isTaskCompleted: true },
		],
		duration: "",
		averageDuration: "",
		completedBy: "",
		stepCompletedInPercentage: 40,
		comments: [{ comment: "completed", fullName: "Lefatse Mhlaba" }],
		cutOffDescription: "Submitted 1 second after cut-of",
		cutOffColor: "green-text",
	},
	{
		supplierDocId: 1,
		supplierDocStepId: 1,
		stepStatusId: 1,
		stepStatus: "Completed",
		sequenceNumber: 4,
		cutOffTime: "",
		dateSubmitted: "",
		dateReviewed: "09/12/2022 - 10:12 am",
		dateCaptured: "",
		datePaid: "",
		stepNumber: 2.0,
		description: "End User Review",
		assignToUsers: [
			{ userId: 3, fullName: "ETQ A", isTaskCompleted: true },
			{ userId: 2, fullName: "Dan Davis", isTaskCompleted: false },
		],
		duration: "",
		averageDuration: "",
		completedBy: "",
		stepCompletedInPercentage: 40,
		comments: [{ comment: "completed", fullName: "ETQ A" }],
		cutOffDescription: "",
	},
	{
		supplierDocId: 1,
		supplierDocStepId: 1,
		stepStatusId: 1,
		stepStatus: "Completed",
		sequenceNumber: 5,
		cutOffTime: "",
		dateSubmitted: "",
		dateReviewed: "",
		dateCaptured: "09/12/2022 - 10:19 am",
		datePaid: "",
		stepNumber: 3.0,
		description: "Finance Capturing",
		assignToUsers: [
			{ userId: 4, fullName: "Finance", isTaskCompleted: true },
			{ userId: 5, fullName: "Tina Tomson", isTaskCompleted: false },
		],
		duration: "",
		averageDuration: "",
		completedBy: "",
		stepCompletedInPercentage: 40,
		comments: [{ comment: "completed", fullName: "Finance" }],
		cutOffDescription: "",
	},
	{
		supplierDocId: 1,
		supplierDocStepId: 1,
		stepStatusId: 1,
		stepStatus: "Completed",
		sequenceNumber: 6,
		cutOffTime: "",
		dateSubmitted: "",
		dateReviewed: "",
		dateCaptured: "",
		datePaid: "21/12/2022 - 12:40 pm",
		stepNumber: 4.0,
		description: "Payment Processing",
		assignToUsers: [
			{ userId: 4, fullName: "Finance", isTaskCompleted: true },
			{ userId: 5, fullName: "Tina Tomson", isTaskCompleted: false },
		],
		duration: "",
		averageDuration: "",
		completedBy: "",
		stepCompletedInPercentage: 40,
		comments: [{ comment: "completed", fullName: "Finance" }],
		cutOffDescription: "",
	},
];

export const SupplierDocumentStepHistory: React.FC = () => {
	const getClassName = (status: string) => {
		let classes: string = "steps-root ";
		if (status === SupplierDocumentStepHistoryStatus.Ready) {
			classes += "in-progress";
		}
		if (status === SupplierDocumentStepHistoryStatus.Completed) {
			classes += "complete";
		}
		if (status === SupplierDocumentStepHistoryStatus.Recalled) {
			classes += "recall";
		}
		if (status === SupplierDocumentStepHistoryStatus.ChangeRequested) {
			classes += "change-request";
		}
		if (status === SupplierDocumentStepHistoryStatus.Rejected) {
			classes += "reject";
		}
		if (status === SupplierDocumentStepHistoryStatus.Deleted) {
			classes += "delete";
		}
		if (status === SupplierDocumentStepHistoryStatus.Delegated) {
			classes += "delegate";
		}
		if (status === SupplierDocumentStepHistoryStatus.Escalated) {
			classes += "escalate";
		}
		if (status === SupplierDocumentStepHistoryStatus.Cancelled) {
			classes += "cancel";
		}
		return classes;
	};

	return (
		<div className="history-panel">
			<div className="heading-part">
				<Typography variant="h4">
					Invoice Upload - Processing History
				</Typography>
				{stepHistoryList.length > 0 && (
					<div className="stepper-wrapper">
						<Typography variant="caption">
							{`${stepHistoryList[0].stepCompletedInPercentage}% Completed`}
						</Typography>
						<Box sx={{ ml: 1, maxWidth: 400, flexGrow: 1 }}>
							<LinearProgress
								variant="determinate"
								value={stepHistoryList[0].stepCompletedInPercentage}
							/>
						</Box>
					</div>
				)}
			</div>
			<div className="steps-wrapper">
				{!stepHistoryList.length && (
					<Typography
						className="steps-root"
						variant="body1"
						justifyContent="center"
					>
						No Data Available
					</Typography>
				)}
				{stepHistoryList.length > 0 &&
					stepHistoryList.map(
						(item: ISupplierDocStepHistory, index: number) => (
							<Link
								key={index}
								onClick={(e) => {
									e.preventDefault();
								}}
								underline="none"
								className={`${getClassName(item.stepStatus)} ${
									index === 1 && "active"
								}`} // TODO: Replace 1 with active step index
								style={{
									cursor: "pointer",
								}}
								id={index === 1 ? "active" : undefined} // TODO: Replace 1 with active step index
							>
								<Tooltip title={item.stepStatus} placement="bottom">
									<div className="steps-icon">{item.stepNumber}</div>
								</Tooltip>
								<div className="step-content">
									<Typography variant="body2">{item.description}</Typography>
									<Typography variant="caption">
										{item.assignToUsers.map((user, index) => (
											<span
												key={index}
												className={
													user.isTaskCompleted ? "green-text fw-500" : ""
												}
											>{`${user.fullName}${
												index !== item.assignToUsers.length - 1 ? ", " : ""
											}`}</span>
										))}
									</Typography>
									<div className="step-content-middle">
										{item.cutOffTime && (
											<>
												<div className="left-part">
													<Typography variant="caption" className="light">
														Cut-off Time
													</Typography>
													<Typography variant="caption">
														{item.cutOffTime}
													</Typography>
												</div>
												<div className="right-part">
													<Tooltip
														placement="top"
														title="Invoices must be submitted before the stipulated cut-off time. SASSETA will process invoices submitted after the cut-off time the next business day, and the invoice submission date will be recorded as the next business day."
													>
														<span>
															<Avatar
																src={infoIcon}
																alt="Info"
																style={{ height: "24px", width: "24px" }}
															/>
														</span>
													</Tooltip>
												</div>
											</>
										)}
									</div>
									<div className="step-content-bottom">
										<div className="left-part">
											<Typography variant="caption" className="light">
												{`Date ${
													item.dateSubmitted
														? "Submitted"
														: item.dateReviewed
														? "Reviewed"
														: item.dateCaptured
														? "Captured"
														: item.datePaid
														? "Paid"
														: ""
												}`}
											</Typography>
											<Typography variant="caption">
												{item.dateSubmitted ||
													item.dateReviewed ||
													item.dateCaptured ||
													item.datePaid ||
													""}
											</Typography>
										</div>
										{item.comments.length > 0 && (
											<CustomTooltip
												tooltipStyle={{
													border: "1px solid #034f8b",
												}}
												tooltipProps={{
													title: item.comments.map(
														(cmt: IStepHistoryComment, index: number) => (
															<Grid
																container
																key={index}
																className={index !== 0 ? "history-comment" : ""}
															>
																<Grid item xs={12} className="fw-500">
																	{cmt.fullName}
																</Grid>
																<Grid item xs={12} mt={1}>
																	{cmt.comment}
																</Grid>
															</Grid>
														)
													),
													className: "history-tooltip",
													placement: "right",
													children: (
														<IconButton>
															<CommentIcon />
														</IconButton>
													),
												}}
											/>
										)}
									</div>
									{item.cutOffDescription && (
										<div className="step-content-bottom">
											<div className="left-part">
												<Typography
													variant="caption"
													className={item.cutOffColor}
												>
													{item.cutOffDescription}
												</Typography>
											</div>
										</div>
									)}
								</div>
							</Link>
						)
					)}
			</div>
		</div>
	);
};
